let tagCheckbox = document.querySelectorAll('#filterform .custom-radio input');
for (let i = 0; i < tagCheckbox.length; i++) {
    tagCheckbox[i].addEventListener('change', filterChanged);
}

var parts = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
if (parts.indexOf('http://') != 0 || parts.indexOf('https://') != 0) {
    parts.forEach(function (item, index) {
        var param = item.split('=');
        var key = param[0];
        var value = decodeURIComponent(param[1]).split(',');
        for (var j = 0; j < value.length; ++j) {
            var filterOptions = document.getElementsByName(key);
            for (var i = 0; i < filterOptions.length; i++) {
                value[j].replace(/\s/g, '');
                if (filterOptions[i].value === value[j]) {
                    filterOptions[i].setAttribute('checked', true)
                }
            }
        }
    });
}

function filterChanged() {
    var arrayChecked = []
    var checkboxes = document.querySelectorAll('#filterform input[type=radio]:checked');
    for (var i = 0; i < checkboxes.length; i++) {
        var key = checkboxes[i].name;
        var info = checkboxes[i].value;
        var temp = {};

        if (arrayChecked[key]) {
            arrayChecked[key].push(info);
        } else {
            arrayChecked[key] = [info];
        }
    }

    var url = document.querySelector('#filterform').getAttribute('data-url');
    for (var key in arrayChecked) {
        url += (url.indexOf('?') >= 0) ? '&' : '?';
        url += key + '=' + arrayChecked[key].join(',');
    }
    window.location.href = url;
}
